import { Component } from '@angular/core';

@Component({
  selector: 'app-cookies-policy',
  imports: [],
  templateUrl: './cookies-policy.html',
  styleUrl: './cookies-policy.less'
})
export class CookiesPolicy {

}
